var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "q-pb-xl layout-padding" }, [
    _c(
      "div",
      { staticClass: "row" },
      [
        _c(
          "h5",
          {
            staticClass: "q-pa-md col-12",
            staticStyle: { "padding-bottom": "0" }
          },
          [
            _c("q-icon", {
              attrs: { color: "primary", name: "fa fa-graduation-cap" }
            }),
            _vm._v(" Instructor Information\n    ")
          ],
          1
        ),
        _vm.$p(["ADMIN", "MANAGER", "RECRUITER"], "or") || _vm.isUserWizard
          ? _c(
              "q-field",
              {
                staticClass: "q-pa-md col-12",
                attrs: {
                  "error-label": "Please add at least one Affiliate!",
                  error:
                    _vm.validation.instructorForm.INSTRUCTOR_AFFILIATES.$error
                }
              },
              [
                _c("q-select", {
                  attrs: {
                    chips: "",
                    multiple: "",
                    "float-label": "Associated Affiliates",
                    value: _vm.affiliateIds,
                    options: _vm.affiliateOptions,
                    filter: "",
                    "autofocus-filter": "",
                    after: [
                      {
                        icon: "flag",
                        condition:
                          _vm.validation.instructorForm.INSTRUCTOR_AFFILIATES
                            .$invalid
                      },
                      {
                        icon: "fa fa-check",
                        condition: !_vm.validation.instructorForm
                          .INSTRUCTOR_AFFILIATES.$invalid
                      }
                    ],
                    disable: !_vm.canEdit
                  },
                  on: {
                    input: function(affiliateIds) {
                      return this$1.updateInstructorForm({
                        field: "INSTRUCTOR_AFFILIATES",
                        value: affiliateIds.map(function(affiliateId) {
                          return { AFFILIATE_ID: affiliateId }
                        })
                      })
                    }
                  }
                })
              ],
              1
            )
          : _vm._e(),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-6",
            attrs: {
              "error-label": "Instructor Code is required",
              error: _vm.validation.instructorForm.INSTRUCTOR_CODE.$error,
              helper: _vm.$p(["ADMIN", "MANAGER"], "or")
                ? ""
                : "Assigned By Manager"
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Instructor Code",
                value: _vm.instructorForm.INSTRUCTOR_CODE,
                after: [
                  {
                    icon: "flag",
                    condition:
                      _vm.validation.instructorForm.INSTRUCTOR_CODE.$invalid
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.instructorForm.INSTRUCTOR_CODE
                      .$invalid
                  }
                ],
                disable:
                  (!_vm.canEdit && _vm.mode == "edit") ||
                  !_vm.$p(["ADMIN", "MANAGER"], "or") ||
                  _vm.activeApprovalStatus === "APPROVED",
                required: ""
              },
              on: {
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateInstructorForm({
                    field: "INSTRUCTOR_CODE",
                    value: $event.target.value
                  })
                },
                blur: _vm.validation.instructorForm.INSTRUCTOR_CODE.$touch
              }
            })
          ],
          1
        ),
        _c(
          "q-field",
          {
            staticClass: "q-pa-md col-6",
            attrs: {
              "error-label": "Drivers License Number is required",
              error: _vm.validation.instructorForm.DRIVERS_LICENSE.$error
            }
          },
          [
            _c("q-input", {
              attrs: {
                "float-label": "Drivers License Number",
                value: _vm.instructorForm.DRIVERS_LICENSE,
                after: [
                  {
                    icon: "flag",
                    condition:
                      _vm.validation.instructorForm.DRIVERS_LICENSE.$invalid,
                    handler: function handler() {}
                  },
                  {
                    icon: "fa fa-check",
                    condition: !_vm.validation.instructorForm.DRIVERS_LICENSE
                      .$invalid
                  }
                ],
                disable: !_vm.canEdit,
                required: ""
              },
              on: {
                blur: _vm.validation.instructorForm.DRIVERS_LICENSE.$touch,
                keyup: function($event) {
                  $event.stopPropagation()
                  _vm.updateInstructorForm({
                    field: "DRIVERS_LICENSE",
                    value: $event.target.value
                  })
                }
              }
            })
          ],
          1
        ),
        !_vm.$p(["ADMIN", "MANAGER"], "or") &&
        (!_vm.instructorForm.INSTRUCTOR_ID || _vm.instructorForm.ACTIVE_IND) &&
        _vm.instructorForm.LK_INSTRUCTOR_STATUS_ID != 1
          ? _c(
              "div",
              { staticClass: "panel" },
              [
                _c("q-icon", {
                  attrs: { name: "fa fa-warning", size: "30px" }
                }),
                _vm._v(
                  " Your instructor code will be provided to you by your manager. After creating the instructor, they will be sent for Approval.\n    "
                )
              ],
              1
            )
          : _vm._e(),
        _vm.$p(["ADMIN", "MANAGER"], "or") &&
        _vm.instructorForm.ACTIVE_IND &&
        _vm.instructorForm.LK_INSTRUCTOR_STATUS_ID != 1
          ? _c(
              "div",
              { staticClass: "panel" },
              [
                _c("q-icon", {
                  attrs: { name: "fa fa-warning", size: "30px" }
                }),
                _vm.validation.instructorForm.INSTRUCTOR_CODE.$invalid
                  ? _c("span", [_vm._v("Please assign an instructor code.")])
                  : _vm._e(),
                _vm._v(" This instructor is pending approval.\n    ")
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }